import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchMyOrders = createAsyncThunk(
  "orders/fetchMyOrders",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${apiUrl}/trade/getAllTradesByUserId?userId=${userId}`
      );
      let orders = response.data || [];
      orders = orders.filter((order) => order.status !== "CANCELED");
      return orders;
    } catch (error) {
      return rejectWithValue("Failed to fetch orders.");
    }
  }
);

export const postNewOrder = createAsyncThunk(
  "orders/postNewOrder",
  async ({ orderData, userId, email }, { rejectWithValue }) => {
    const mappedData = {
      amount: orderData.max/orderData.rate,
      primary_currency: orderData.to,
      secondary_currency: orderData.from,
      rate: orderData.rate,
      user_id: userId,
      email: email,
      default_card: orderData.selectedCard.id,
      default_bank: orderData.selectedAccount.bankAccountId,
    };

    try {
      const response = await axios.post(`${apiUrl}/trade/create`, mappedData);
      console.log('console.log(response.data);',response.data);
      if (response.data.status==='CREATED') {
        alert("Order Creation Successful.");
        return response.data.orders;
      } else {
        return rejectWithValue("Failed to post new order.");
      }
    } catch (error) {
      return rejectWithValue("Failed to post new order.");
    }
  }
);

export const updateOrder = createAsyncThunk(
  "orders/updateOrder",
  async (orderData, { rejectWithValue }) => {
    const mappedData = {
      id: orderData.id,
      amount: orderData.max,
      rate: orderData.rate,
    };
    try {
      const response = await axios.patch(`${apiUrl}/trade/update`, mappedData);
      if (response.data.success) {
        return response.data.orders;
      } else {
        return rejectWithValue("Failed to update order.");
      }
    } catch (error) {
      return rejectWithValue("Failed to update order.");
    }
  }
);

export const deleteOrder = createAsyncThunk(
  "orders/deleteOrder",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/trade/cancel?tradeId=${orderId}`
      );
      if (response.data.success) {
        return response.data.orders;
      } else {
        return rejectWithValue("Failed to delete order.");
      }
    } catch (error) {
      return rejectWithValue("Failed to delete order.");
    }
  }
);
